module.exports = __webpack_public_path__ + "static/media/healthcom.1f6fccca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/experiences/healthcom.png
// module id = 100
// module chunks = 0